export const AUTH_ROUTES = {
  LOGIN: '/login',
  SIGNUP: '/signup',
  FORGOT_PASSWORD: '/forgot-password',
  RESET_PASSWORD: '/reset-password',
  VERIFY_EMAIL: '/verify-email',
  JOIN_MEET: '/join-meet',
  OIDC_CALLBACK: '/auth/callback',
} as const

export const APP_ROUTES = {
  ROOT: '/',
  DASHBOARD_HOME: '/meetings',
} as const
